<template>
  <div class="box">
    <!-- 顶部组件 -->
    <top-navigation
      :loginDialog="loginDialog"
      @loginClose="loginClose"
    ></top-navigation>
    <!-- 内容 -->
    <div class="searchBox">
      <div class="demo-input-suffix">
        <span>品牌研究资源-搜索：</span>
        <el-input
          placeholder="请输入您要查询的关键词"
          v-model="seachList.name"
          style="width: 700px"
        >
          <el-button
            class="but"
            slot="append"
            icon="el-icon-search"
            @click="query"
          ></el-button>
        </el-input>
      </div>
    </div>
    <div class="center mt">
      <div class="flex-row-between">
        <div class="left">
          <div class="title">按照条件筛选论文</div>
          <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;">
            <div class="seachBox" v-for="(item, index) in oneList" :key="index">
              <div class="seachTitle">
                <div class="seachleft">{{ item.typeName }}</div>
                <img
                  @click="changeOne(item)"
                  v-if="item.choose"
                  src="../../assets/image/query/arrow_down.png"
                  alt=""
                />
                <img
                  @click="changeOne(item)"
                  v-else
                  class="close"
                  src="../../assets/image/query/arrow_down.png"
                  alt=""
                />
              </div>
              <div
                class="seachCen"
                v-show="item.choose"
                v-for="(it, ix) in item.subList"
                :key="ix"
                @click="changeTwe(it)"
              >
                <div :class="it.choose ? 'cneleft_active' : 'cneleft'">
                  {{ it.subTypeName }}
                </div>
                <div v-if="it.choose" class="cneright">关闭</div>
                <div v-else class="cneright">({{ it.resourcesCount }})</div>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <div class="right">
          <div class="thesisBox" v-for="(item, index) in list" :key="index">
            <div class="thesisTitle">
              <div class="thesisleft">
                {{ index + 1 * seachList.pageNum }}.{{ item.name }}
              </div>
              <div class="thesisUpdwon">下载: {{ item.downloadCounts }}次</div>
            </div>
            <div class="thesisAuthor">
              <span>{{ item.author }}</span>
              <span>&nbsp;|&nbsp;</span>
              <span>{{ item.publishYear }}</span>
              <span>&nbsp;|&nbsp;</span>
              <span>{{ item.publishJournal }}</span>
            </div>
            <div class="thesisAbstract">
              {{ item.thesisAbstract }}
            </div>
            <div class="thesisBottom flex-row-between">
              <div>
                <span class="bot" v-for="(it, ix) in item.keywords" :key="ix">{{
                  it
                }}</span>
              </div>
              <div>
                <div class="bottomBut" @click="seePdf(item)">
                  <img
                    class="img1"
                    src="../../assets/image/resourceManage/chakan1.png"
                    alt=""
                  />
                  <img
                    class="img2"
                    src="../../assets/image/resourceManage/chakan2.png"
                    alt=""
                  />
                  <span>查看</span>
                </div>
                <div class="bottomBut2" @click="upDown(item)">
                  <img
                    class="img1"
                    src="../../assets/image/resourceManage/xiazai1.png"
                    alt=""
                  />
                  <img
                    class="img2"
                    src="../../assets/image/resourceManage/xiazai2.png"
                    alt=""
                  />
                  <span>下载</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 空页面 -->
          <div class="_kongbai" v-if="list.length == 0">
            <div class="_kong">
              <img src="../../assets/image/query/kongbai.png" alt="" />
              <div>当前暂无内容</div>
            </div>
          </div>
          <el-pagination
            v-if="list.length > 0"
            class="msg-pagination-container"
            :background="isBackground"
            next-text="下一页"
            layout="pager, next"
            @current-change="handleCurrentChange"
            :page-size="seachList.pageSize"
            :current-page.sync="seachList.pageNum"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <footer-2></footer-2>
  </div>
</template>

<script>
import Footer2 from "../../components/footer/footer2.vue";
import topNavigation from "../../components/topNavigation/topNavigation.vue";
import {
  thesisCount,
  getPcThesisResource,
  pcReadThesis,
} from "@/api/resourceManage";
export default {
  components: { topNavigation, Footer2 },
  data() {
    return {
      isBackground: true, // 分页颜色
      loginDialog: false, // 登录弹窗状态
      seachList: {
        pageNum: 1,
        pageSize: 10,
        name: "", // 品牌资源名称, 或者模糊搜索字段
        thesisSubTypeArr: [], // 论文二级分类数组
      },
      total: 0,
      list: "", // 论文列表
      oneList: "", //一级论文分类列表
      changeList: [],
      url:
        location.host == "www.zhuowendata.com"
          ? "https://www.zhuowendata.com"
          : "https://dev.quickbusiness.cn",
    };
  },
  created() {
    window.scrollTo(0, 0); // 回滚
    // 获取一级论文分类列表
    this.thesisCount();
    this.getData();
  },
  methods: {
    // 查询
    query() {
      this.seachList.pageNum = 1;
      this.getData();
    },
    // 下载pdf
    upDown(item) {
      let str = `id=${item.id}`;
      console.log(str);
      window.open(
        this.url + `/apis/survey/thesisResources/downloadThesis?${str}`
      );
      console.log(
        this.url + `/apis/survey/thesisResources/downloadThesis?${str}`
      );
      this.getData();
    },
    // 查看Pdf
    seePdf(item) {
      pcReadThesis({ id: item.id }).then((res) => {
        if (res.code == 200) {
          window.open(item.fileUrl, "_blank");
          this.getData();
        }
      });
    },
    // 品牌研究资源
    getData() {
      this.seachList.thesisSubTypeArr = [];
      if (this.changeList.length > 0) {
        this.changeList.forEach((item, index) => {
          this.seachList.thesisSubTypeArr.push(item.subTypeValue);
        });
      } else {
        this.seachList.thesisSubTypeArr = [];
      }
      getPcThesisResource(this.seachList).then((res) => {
        if (res.code == 200) {
          this.total = res.data.total;
          res.data.list.forEach((item) => {
            item.keywords = item.keywords.split(",");
          });
          this.list = res.data.list;
        }
      });
    },
    // 二级论文分类选择
    changeTwe(it) {
      it.choose = !it.choose;
      // 每个一级分类下只能选择一个
      this.oneList.forEach((item) => {
        if (item.typeId == it.preTypeValue) {
          item.subList.forEach((i) => {
            if (it.subTypeId != i.subTypeId) {
              i.choose = false;
            }
            this.changeList.forEach((item, index) => {
              if (i.subTypeId == item.subTypeId) {
                this.changeList.splice(index, 1);
              }
            });
          });
        }
      });
      // 处理选择
      if (it.choose) {
        this.changeList.push(it);
      } else {
        this.changeList.forEach((item, index) => {
          if (it.subTypeId == item.subTypeId) {
            this.changeList.splice(index, 1);
          }
        });
      }
      this.getData();
      console.log(this.changeList);
    },
    // 一级论文分类选择
    changeOne(val) {
      val.choose = !val.choose;
    },
    // 获取一级论文分类列表
    thesisCount() {
      thesisCount().then((res) => {
        if (res.code == 200) {
          res.data.forEach((item, index) => {
            item.choose = true;
            item.subList.forEach((it) => {
              it.choose = false;
            });
          });
          this.oneList = res.data;
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.seachList.pageNum = val;
    },
    // 登录状态回调
    loginClose(data) {
      this.loginDialog = data;
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 0px) and (max-width: 1440px) {
  .mt {
    width: 1440px;
    margin: 0 auto;
  }
  .box {
    min-width: 1440px;
  }
  .thesisBox {
    width: 1156px;
  }
  ._kongbai {
    width: 1156px;
  }
}
@media screen and (min-width: 1441px) and (max-width: 1920px) {
  .mt {
    width: 1680px;
    margin: 0 auto;
  }
  .box {
    min-width: 1680px;
  }
  .thesisBox {
    width: 1396px;
  }
  ._kongbai {
    width: 1396px;
  }
}
.flex-row-start {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}
.flex-row-between {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
}
.box {
  background: #f3f5f9;
}
.close {
  float: left;
  width: 36px;
  height: 36px;
  cursor: pointer;
  transform: rotate(-90deg);
}
.searchBox {
  height: 98px;
  background: linear-gradient(176deg, #0f81d9 0%, #071c76 100%);
  text-align: center;
  line-height: 98px;
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
  /deep/.el-input__inner {
    height: 48px;
    border-radius: 4px 0 0 4px;
  }
  .but {
    background-color: #fff;
  }
  /deep/.el-input-group__append {
    background-color: #fff !important;
    border: 0px !important;
  }
  /deep/.el-icon-search {
    color: #0087fa !important;
    font-size: 18px;
  }
}
.center {
  margin-top: 24px;

  .left {
    width: 268px;
    height: 681px;
    background: #ffffff;
    border-radius: 6px;
    padding: 22px 24px;
    box-sizing: border-box;
    cursor: default;
    .title {
      width: 112px;
      height: 13px;
      font-size: 14px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #677985;
      line-height: 13px;
    }
    .seachBox {
      margin-top: 12px;
      width: 220px;
      border: 1px solid #ecf3f8;
      .seachTitle {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        .seachleft {
          width: 184px;
          height: 36px;
          background: #ecf3f8;
          font-size: 16px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #677985;
          line-height: 36px;
          padding: 0 15px;
          box-sizing: border-box;
        }
        img {
          cursor: pointer;
        }
      }
      .seachCen {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        padding: 10px 16px;
        cursor: pointer;
        .cneleft {
          font-size: 14px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #677985;
          line-height: 20px;
        }
        .cneright {
          font-size: 14px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #c2c9ce;
          line-height: 21px;
        }
        .cneleft_active {
          font-size: 14px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #007aff;
          line-height: 21px;
        }
      }
    }
  }
  .right {
    .thesisBox {
      height: 192px;
      background: #ffffff;
      border-radius: 6px;
      padding: 18px 23px;
      box-sizing: border-box;
      margin-bottom: 16px;
      cursor: default;
      .thesisTitle {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        .thesisleft {
          width: 90%;
          //超出一行省略号
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 700;
          color: #203644;
          line-height: 20px;
        }
        .thesisUpdwon {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #8997a1;
          line-height: 20px;
        }
      }
    }
    .thesisAuthor {
      margin-top: 10px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8997a1;
      line-height: 20px;
    }
    .thesisAbstract {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8997a1;
      line-height: 20px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden; //溢出内容隐藏
      text-overflow: ellipsis; //文本溢出部分用省略号表示
      display: -webkit-box; //特别显示模式
      -webkit-line-clamp: 2; //行数
      line-clamp: 2;
      -webkit-box-orient: vertical; //盒子中内容竖直排列
      margin-top: 12px;
    }
    .thesisBottom {
      margin-top: 16px;
      .bot {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8997a1;
        line-height: 20px;
        text-decoration: underline;
        margin-right: 16px;
      }
      .bottomBut {
        width: 72px;
        height: 32px;
        border-radius: 2px;
        border: 1px solid #d1d6da;
        line-height: 32px;
        text-align: center;
        vertical-align: middle;
        display: inline-block;
        cursor: pointer;
        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #8997a1;
          vertical-align: middle;
          padding-bottom: 2px;
          display: inline-block;
        }
        .img1 {
          display: block;
          display: inline-block;
        }
        .img2 {
          display: none;
        }
      }
      .bottomBut:hover {
        border: 1px solid #66b7fc;
        span {
          color: #66b7fc;
        }
        .img2 {
          display: block;
          display: inline-block;
        }
        .img1 {
          display: none;
        }
      }
      .bottomBut2 {
        width: 72px;
        height: 32px;
        border-radius: 2px;
        border: 1px solid #d1d6da;
        line-height: 32px;
        text-align: center;
        vertical-align: middle;
        display: inline-block;
        margin-left: 16px;
        cursor: pointer;
        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #8997a1;
          vertical-align: middle;
          padding-bottom: 5px;
          display: inline-block;
        }
        .img1 {
          display: block;
          display: inline-block;
        }
        .img2 {
          display: none;
        }
      }
      .bottomBut2:hover {
        border: 1px solid #66b7fc;
        span {
          color: #66b7fc;
        }
        .img2 {
          display: block;
          display: inline-block;
        }
        .img1 {
          display: none;
        }
      }
    }
    ._kongbai {
      ._kong {
        margin-top: 200px;
        text-align: center;
        img {
          width: 279px;
          height: 191px;
        }
        div {
          text-align: center;
        }
      }
    }
  }
}
/deep/.el-pagination {
  margin-top: 20px;
  float: right;
  .el-pager li {
    font-size: 14px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #8996a0;
    line-height: 28px;
    width: 28px;
    height: 28px;
    background: #ffffff;
    border-radius: 3px;
  }
  .btn-next {
    width: 56px;
    height: 28px;
    background: #ffffff;
    line-height: 28px;
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #a4c7ff;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/resourceManage/resourceManage.vue